import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface CheckCircleFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

// Filled tone circle with the check punched out (evenodd) so the glyph reads as
// the surface behind it — the same cutout treatment as InfoCircleFilledIcon.
export const CheckCircleFilledIcon: React.FC<CheckCircleFilledIconProps> = ({
  size = 24,
  color = 'iconPositive',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1.7 14.3l-3.6-3.6 1.4-1.4 2.2 2.2 4.9-4.9 1.4 1.4-6.3 6.3z"
        fill={colors[color]}
      />
    </Svg>
  );
};

CheckCircleFilledIcon.displayName = 'CheckCircleFilledIcon';
